import { _firestore } from '@/lib/db';

export const SaveTableSettings =  ( uid, table, settings ) => _firestore.collection( 'users' )
	.doc( uid )
	.collection( 'tableSettings' )
	.doc( table )
	.set( settings );

export const GetTableSettings = ( uid, tableName, cb ) => _firestore.collection( 'users' )
	.doc( uid )
	.collection( 'tableSettings' )
	.doc( tableName )
	.onSnapshot( doc => cb( doc.data() ) );
